export function thousandNumberSeperator(
  value: number | string
): string {
  const numericValue = typeof value === "number" ? value : parseFloat(value);

  if (isNaN(numericValue)) {
    return '-';
  }

  const decimalPart = value.toString().split(".")[1];
  const decimals = decimalPart ? decimalPart.length : 0;

  // Format the number
  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  };

  return new Intl.NumberFormat('da-DK', options).format(numericValue);
}